const topics = [
  {
    title: '台北娜娜情感揭秘',
    desc: '台北娜娜最新恋情曝光，男方身份疑似圈内知名制作人，细节深扒不容错过',
    tag: '热门',
    tagColor: 'bg-primary-500',
  },
  {
    title: '莫里秀最新动态',
    desc: '莫里秀直播翻车事件全复盘，从口误到道歉完整时间线梳理',
    tag: '新',
    tagColor: 'bg-accent-500',
  },
  {
    title: '玩偶姐姐身份深扒',
    desc: '神秘玩偶姐姐真实身份大起底，背后团队与运营模式全面曝光',
    tag: '爆',
    tagColor: 'bg-primary-500',
  },
  {
    title: '网红黑料大起底',
    desc: '多位头部网红私下言论与行为被扒，人设崩塌现场实录',
    tag: '热',
    tagColor: 'bg-accent-500',
  },
  {
    title: '明星塌房实录',
    desc: '近期明星塌房事件汇总，从偷税漏税到感情纠纷一网打尽',
    tag: '新',
    tagColor: 'bg-accent-500',
  },
  {
    title: '娱乐圈内幕揭秘',
    desc: '资深业内人士匿名爆料，揭开娱乐圈不为人知的潜规则',
    tag: '深',
    tagColor: 'bg-secondary-500',
  },
  {
    title: '素人爆料精选',
    desc: '素人投稿精选合集，来自民间的真实爆料往往更加劲爆',
    tag: '精',
    tagColor: 'bg-secondary-500',
  },
  {
    title: '热门事件追踪',
    desc: '持续追踪当下最热门吃瓜事件，不错过任何一个反转瞬间',
    tag: '追',
    tagColor: 'bg-accent-500',
  },
  {
    title: '经典吃瓜回顾',
    desc: '盘点那些年轰动全网的经典吃瓜名场面，重温吃瓜黄金时代',
    tag: '典',
    tagColor: 'bg-secondary-500',
  },
];

export default function SectionIndex() {
  return (
    <section id="index" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选最热门的吃瓜专题，从网红爆料到明星八卦，一站满足你的深扒需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block p-5 md:p-6 bg-background-100 hover:bg-background-200 rounded-xl transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start justify-between gap-3 mb-2">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <span className={`shrink-0 px-2 py-0.5 text-[10px] font-medium text-background-50 rounded-full whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}